import { useEffect, useMemo, useState } from 'react';
import { useRemote } from '../../../Utils/Utils';
import SuggestionMessage from '../../../components/EmptyMessage/SuggestionMessage';
import HorizontalStackedChart from './HorizontalStackedChart';
import AnalyticsToggleHeader from '../Components/AnalyticsToggleHeader';
import AnalyticsHeader from '../Components/AnalyticsHeader';
import { analyticsExportFilename } from '../AnalyticsUtils';
import moment from 'moment';
import "./RechartsOverrides.scss";


const BrowserChart = ({ options, minMenuWidth, valueStyle, labelStyle, height, mb, mt, gap, timeFrame, customeDate }) => {
	const remote = useRemote();
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [dateRange, setDateRange] = useState(timeFrame)
	const [label, setLabel] = useState(options[0].label)
	const dropdownOptions = options.map(o => o.label)

	useEffect(() => {
		if (customeDate && customeDate.from && customeDate.to) {
			setLoading(true);
			const selected = options.find(o => o.label === label)
			const end = moment(customeDate.to).format('YYYY-MM-DD');
			const start = moment(customeDate.from).format('YYYY-MM-DD');

			remote.get(`/analytics/device?from=${start}&to=${end}&type=${selected.value}`).then(d => {
				const newData = [];
				for (let val in d) {
					newData.push({
						"name": val, "value": d[val]
					})
				}
				let sortedData = newData.sort((a, b) => b.value - a.value);
				setData(sortedData);
				setLoading(false);
			}).catch(() => setLoading(false));
		}
	}, [label, dateRange, customeDate]);


	const exportHeaders = useMemo(() => [
		{ label: label, key: 'name' },
		{ label: 'Count', key: 'value' },
	], [label]);

	const exportSlug = useMemo(() => {
		const selected = options.find(o => o.label === label);
		const v = (selected && selected.value) ? selected.value : label;
		return `${String(v).toLowerCase()}-usage`;
	}, [options, label]);

	const exportFilename = useMemo(
		() => analyticsExportFilename(exportSlug, customeDate),
		[exportSlug, customeDate]
	);

	return (
		<> {options.length > 1
			? <AnalyticsToggleHeader
				value={label}
				values={dropdownOptions}
				setValue={setLabel}
				selectedDateRange={timeFrame}
				setSelectedDateRange={setDateRange}
				minMenuWidth={minMenuWidth}
				centralizedDateRange
				mb={mb} mt={mt}
				exportHeaders={exportHeaders}
				exportData={data}
				exportFilename={exportFilename}
				exportLoading={loading}
			/>
			: <AnalyticsHeader
				timeFrame={timeFrame}
				setTimeFrame={setDateRange}
				mb={mb}
				mt={mt}
				exportHeaders={exportHeaders}
				exportData={data}
				exportFilename={exportFilename}
				exportLoading={loading}
			>{label}</AnalyticsHeader>
		}

			{data.length === 0
				? <SuggestionMessage message='No data to display' />
				: <HorizontalStackedChart data={data} tooltips valueStyle={valueStyle || {}} height={height} labelStyle={labelStyle || {}} gap={gap} />
			}
		</>
	);
}

export default BrowserChart;